module.exports = __webpack_public_path__ + "img/call_outlined.49eb7409.svg";